import React from "react";
import { usePageMeta } from "@/lib/usePageMeta";
import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  usePageMeta({
    title: "Obchodní podmínky | STK Komfort Znojmo",
    description:
      "Obchodní podmínky STK Komfort Znojmo pro zajištění STK, emisí, evidenčních kontrol, přepisů vozidel a dalších auto služeb ve Znojmě a okolí.",
    canonical: "https://www.stkkomfort.cz/obchodni-podminky",
  });

  return (
    <LegalLayout
      title="Obchodní podmínky"
      lead="Tyto obchodní podmínky upravují vztah mezi STK Komfort™ a zákazníkem při poskytování auto asistenčních a zprostředkovatelských služeb ve Znojmě a okolí."
    >
      <h2>1. Úvodní ustanovení</h2>
      <p>
        Tyto obchodní podmínky (dále jen &bdquo;OP&ldquo;) upravují pravidla poskytování asistenčních
        a zprostředkovatelských služeb projektu STK Komfort™ a vztahy mezi poskytovatelem
        služby a zákazníkem.
      </p>

      <h2>2. Identifikace poskytovatele</h2>
      <p>
        Projekt STK Komfort™ je obchodně a agenturně zastřešen společností{" "}
        <strong>UNOEXTREME Capital Group s.r.o.</strong>, IČO 09361430, sídlem
        Děčínská 552/1, Střížkov, 180 00 Praha. Zákaznický kontakt: Lenka Garguláková,{" "}
        <a href="tel:+420775659129">+420 775 659 129</a>.
      </p>
      <p>
        <em>Pozn.: Před spuštěním finálně specifikovat, který subjekt vystupuje jako přímý
        poskytovatel služby vůči zákazníkovi (zastřešující společnost nebo provozovatel).</em>
      </p>

      <h2>3. Popis služby</h2>
      <p>
        STK Komfort™ je asistenční a zprostředkovatelská služba, která zákazníkům pomáhá
        zajistit STK, emise, evidenční kontroly, přepisy vozidel, převozní značky, registr
        vozidel, pojištění, autoservis, čištění DPF, čištění interiéru, polepy, odtah
        a další úkony spojené s vozidly. <strong>STK Komfort™ není stanice technické kontroly
        ani orgán veřejné správy.</strong>
      </p>

      <h2>4. Objednávka služby</h2>
      <p>
        Objednávku lze provést telefonicky, e-mailem, přes kontaktní formulář nebo skrze
        chatbota Lenka — auto asistentka STK Komfort™. Objednávka je závazná po vzájemném
        odsouhlasení rozsahu a orientační ceny.
      </p>

      <h2>5. Cena a platební podmínky</h2>
      <p>
        Ceny uvedené na webu jsou <strong>orientační</strong>. Konečná cena vždy závisí na
        typu vozidla, rozsahu služby, stavu vozidla, poplatcích STK, správních poplatcích
        úřadu, vzdálenosti, čekání, servisních pracích a materiálu.
      </p>
      <p>
        Konečnou cenu zákazník obdrží před zahájením služby. Platbu lze provést hotově,
        platební kartou nebo bankovním převodem podle dohody.
      </p>

      <h2>6. Třetí strany</h2>
      <p>
        Zákazník bere na vědomí, že některé části služby jsou zajišťovány třetími stranami,
        zejména:
      </p>
      <ul>
        <li>STK a emise — partner <strong>PSOTA Znojmo</strong> a další smluvní stanice</li>
        <li>servisní práce — smluvní autoservis</li>
        <li>pojištění — pojišťovny a zprostředkovatelé</li>
        <li>úřední úkony — registr vozidel a další úřady</li>
      </ul>

      <h2>7. Předání vozidla a dokladů</h2>
      <p>
        Zákazník je povinen předat vozidlo způsobilé k převzetí a poskytnout úplné a pravdivé
        doklady potřebné pro provedení objednané služby (zejména technický průkaz, osvědčení
        o registraci, doklad o pojištění, kupní smlouvu apod.).
      </p>

      <h2>8. Plná moc a součinnost</h2>
      <p>
        Pro vyřízení úředních úkonů (přepis, evidenční kontrola, depozit, převozní značky)
        je obvykle vyžadována plná moc. Zákazník se zavazuje plnou moc dodat nebo podepsat
        a poskytnout potřebnou součinnost.
      </p>

      <h2>9. STK, emise a výsledek kontroly</h2>
      <p>
        Výsledek STK i emisí <strong>vždy závisí na skutečném technickém stavu vozidla</strong>
        {" "}a rozhodnutí příslušné stanice technické kontroly. STK Komfort™ negarantuje
        úspěšné absolvování STK. Pokud vozidlo neprojde, doporučíme další postup, zajistíme
        opravu přes smluvní servis a opakovanou prohlídku za standardních cenových podmínek.
      </p>

      <h2>10. Servisní práce a opravy</h2>
      <p>
        Cena servisních prací se stanoví podle kalkulace smluvního autoservisu na základě
        VIN, rozsahu práce a použitého materiálu. Konečná cena je se zákazníkem odsouhlasena
        před zahájením prací.
      </p>

      <h2>11. Registr vozidel a správní poplatky</h2>
      <p>
        Postup a výše správních poplatků se řídí aktuálními právními předpisy a požadavky
        příslušného úřadu. Správní poplatky úřadu nejsou součástí ceny služby STK Komfort™
        a hradí je zákazník samostatně nebo prostřednictvím zálohy.
      </p>

      <h2>12. Odpovědnost</h2>
      <p>
        STK Komfort™ nenese odpovědnost za skutečný technický stav vozidla, za rozhodnutí
        příslušného úřadu, za rozhodnutí stanice technické kontroly ani za případné závady
        zjištěné v průběhu STK či servisu.
      </p>
      <p>
        Odpovědnost za škodu způsobenou prokazatelným porušením povinností STK Komfort™
        je omezena částkou skutečně uhrazené ceny příslušné služby.
      </p>

      <h2>13. Zrušení objednávky</h2>
      <p>
        Zákazník může objednávku zrušit nejpozději 24 hodin před termínem realizace bez
        storno poplatku. Při pozdějším zrušení může být účtován storno poplatek odpovídající
        nákladům již vynaloženým na přípravu služby.
      </p>

      <h2>14. Reklamace</h2>
      <p>
        Reklamace lze uplatnit telefonicky nebo písemně u kontaktní osoby. Reklamace bude
        vyřízena bez zbytečného odkladu, nejpozději do 30 dnů od jejího uplatnění, pokud
        zákon nestanoví jinak.
      </p>

      <h2>15. Ochrana osobních údajů</h2>
      <p>
        Zpracování osobních údajů upravují{" "}
        <a href="/ochrana-osobnich-udaju">Zásady ochrany osobních údajů</a>.
      </p>

      <h2>16. Závěrečná ustanovení</h2>
      <p>
        Vztahy neupravené těmito OP se řídí příslušnými ustanoveními českého právního řádu,
        zejména občanským zákoníkem a zákonem o ochraně spotřebitele. Poskytovatel je
        oprávněn OP měnit s tím, že na nové znění zákazníka upozorní vhodným způsobem.
      </p>

      <p className="mt-10 text-xs text-slate-500">
        Tyto OP jsou platné od data zveřejnění. Před ostrým spuštěním webu je doporučena
        kontrola textu právníkem.
      </p>
    </LegalLayout>
  );
}
